import SidePanel from '@/components/TreeDoc/SidePanel.jsx'
import useCommentPane from '../../SidePanel/LeftPanel/CommentPane/useCommentPane.jsx'
import useExternalPane from '../../SidePanel/LeftPanel/ExternalPane/useExternalPane.jsx'
import useHiddenPane from '../../SidePanel/LeftPanel/HiddenPane/useHiddenPane.jsx'
import useImportantPane from '../../SidePanel/LeftPanel/ImportantPane/useImportantPane.jsx'
import useInvalidPane from '../../SidePanel/LeftPanel/InvalidPane/useInvalidPane.jsx'
import useMarkPane from '../../SidePanel/LeftPanel/MarkPane/useMarkPane.jsx'
import useMessagePane from '../../SidePanel/LeftPanel/MessagePane/useMessagePane.jsx'
import useSearchPane from '../../SidePanel/LeftPanel/SearchPane/useSearchPane.jsx'
import useSettingsPane from '../../SidePanel/LeftPanel/SettingsPane/useSettingsPane.jsx'
import useUpgradePane from '../../SidePanel/LeftPanel/UpgradePane/useUpgradePane.jsx'
import useSyntaxPane from './SyntaxPane/useSyntaxPane.jsx'

export default function LeftPanelAnalyse(props) {
    const panes = [
        useSearchPane(),
        useImportantPane(),
        useCommentPane(),
        useMarkPane(),
        useMessagePane(),
        useUpgradePane(),
        useInvalidPane(),
        useExternalPane(),
        useHiddenPane(),
        useSyntaxPane(),
        useSettingsPane(),
    ]

    return (
        <SidePanel
            direction="ltr"
            panelId="left"
            panes={panes}
            {...props}
        />
    )
}
